import React from 'react';
import Select from 'react-select';
import chroma from 'chroma-js';

const selectStyles = {
  option: (styles, { data, isDisabled }) => ({
    ...styles,
    ':before': {
      backgroundColor: chroma(data.backgroundColor || '#d7d7d7').css(),
      borderRadius: '50%',
      content: '" "',
      display: 'inline-block',
      marginRight: '8px',
      height: '10px',
      width: '10px',
    },
    color: isDisabled ? '#ccc' : 'inherit',
    cursor: isDisabled ? 'not-allowed' : 'cursor',
    fontSize: '14px',
    letterSpacing: '0.2px',
    lineHeight: '15px',
    textTransform: 'uppercase',
  }),
  multiValue: (styles) => ({
    ...styles,
    border: '1px solid hsl(0,0%,80%)',
    backgroundColor: '#fff',
    borderRadius: '4px',
    marginRight: '6px',
  }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    ':before': {
      backgroundColor: chroma(data.backgroundColor || '#d7d7d7').css(),
      borderRadius: '50%',
      content: '" "',
      display: 'inline-block',
      marginRight: '6px',
      height: '9px',
      width: '9px',
    },
    color: 'inherit',
    padding: '8px 6px 8px 8px !important',
    fontSize: '12px',
    letterSpacing: '0.2px',
    lineHeight: '15px',
    textTransform: 'uppercase',
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: '#a8a29e',
    padding: '8px 4px',
    borderRadius: '0 4px 4px 0',
    cursor: 'pointer',
    transition: 'all 150ms linear',
    ':hover': {
      backgroundColor: '#eee',
      color: 'indianred',
    },
  }),
};

export const StaticCategoriesSelect = ({ value, options, onChange, name, ...props }) => (
  <Select
    name={name}
    className="category-select primary-text-color"
    options={options}
    value={value}
    onChange={onChange}
    styles={selectStyles}
    isMulti
    {...props}
  />
);

export default StaticCategoriesSelect;
